export const AllColors = {
    PRIMARY: 'primary',
    ADDITIONAL: 'additional',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',

    TRANSPARENT: 'transparent',
    CURRENT_COLOR: 'current-color',

    WHITE: 'white',
    GRAY_ULTRA_LIGHT: 'gray-ultra-light',
    GRAY_LIGHT: 'gray-light',
    GRAY: 'gray',
    GRAY_DEEP: 'gray-deep',
    BLACK: 'black',
    BLUE: 'blue',
    INDIGO: 'indigo',
    PURPLE: 'purple',
    LIGHTPINK: 'lightpink',
    PINK: 'pink',
    DEEPPINK: 'deeppink',
    CRIMSON: 'crimson',
    ORANGE: 'orange',
    YELLOW: 'yellow',
    LIGHTYELLOW: 'lightyellow',
    LIGHTGREEN: 'lightgreen',
    LIME: 'lime',
    GREEN: 'green',
    TEAL: 'teal',
    CYAN: 'cyan',
    LIGHTBLUE: 'lightblue',
    STEELBLUE: 'steelblue',

    GRADIENT_GREEN: 'gradient-green',
    GRADIENT_ORANGE: 'gradient-orange',
    GRADIENT_PURPLE: 'gradient-purple',
    GRADIENT_YELLOW: 'gradient-yellow',
    GRADIENT_BLUE: 'gradient-blue',
    GRADIENT_PINK: 'gradient-pink',
    GRADIENT_PALE_GREEN: 'gradient-pale-green',
    GRADIENT_PALE_ORANGE: 'gradient-pale-orange',
    GRADIENT_PALE_PURPLE: 'gradient-pale-purple',
    GRADIENT_PALE_YELLOW: 'gradient-pale-yellow',
    GRADIENT_PALE_BLUE: 'gradient-pale-blue',
    GRADIENT_PALE_PINK: 'gradient-pale-pink',

    GRADIENT_PRIMARY_TOP: 'gradient-primary-top',
    GRADIENT_PRIMARY_LEFT: 'gradient-primary-left',
    GRADIENT_ADDITIONAL_TOP: 'gradient-additional-top',
    GRADIENT_ADDITIONAL_LEFT: 'gradient-additional-left',
    GRADIENT_SUCCESS_TOP: 'gradient-success-top',
    GRADIENT_SUCCESS_LEFT: 'gradient-success-left',
    GRADIENT_WARNING_TOP: 'gradient-warning-top',
    GRADIENT_WARNING_LEFT: 'gradient-warning-left',
    GRADIENT_DANGER_TOP: 'gradient-danger-top',
    GRADIENT_DANGER_LEFT: 'gradient-danger-left',
    GRADIENT_WHITE_TOP: 'gradient-white-top',
    GRADIENT_WHITE_LEFT: 'gradient-white-left',
    GRADIENT_GRAY_ULTRA_LIGHT_TOP: 'gradient-gray-ultra-light-top',
    GRADIENT_GRAY_ULTRA_LIGHT_LEFT: 'gradient-gray-ultra-light-left',
    GRADIENT_GRAY_LIGHT_TOP: 'gradient-gray-light-top',
    GRADIENT_GRAY_LIGHT_LEFT: 'gradient-gray-light-left',
    GRADIENT_GRAY_TOP: 'gradient-gray-top',
    GRADIENT_GRAY_LEFT: 'gradient-gray-left',
    GRADIENT_GRAY_DEEP_TOP: 'gradient-gray-deep-top',
    GRADIENT_GRAY_DEEP_LEFT: 'gradient-gray-deep-left',
    GRADIENT_BLACK_TOP: 'gradient-black-top',
    GRADIENT_BLACK_LEFT: 'gradient-black-left',
    GRADIENT_BLUE_TOP: 'gradient-blue-top',
    GRADIENT_BLUE_LEFT: 'gradient-blue-left',
    GRADIENT_INDIGO_TOP: 'gradient-indigo-top',
    GRADIENT_INDIGO_LEFT: 'gradient-indigo-left',
    GRADIENT_PURPLE_TOP: 'gradient-purple-top',
    GRADIENT_PURPLE_LEFT: 'gradient-purple-left',
    GRADIENT_LIGHTPINK_TOP: 'gradient-lightpink-top',
    GRADIENT_LIGHTPINK_LEFT: 'gradient-lightpink-left',
    GRADIENT_PINK_TOP: 'gradient-pink-top',
    GRADIENT_PINK_LEFT: 'gradient-pink-left',
    GRADIENT_DEEPPINK_TOP: 'gradient-deeppink-top',
    GRADIENT_DEEPPINK_LEFT: 'gradient-deeppink-left',
    GRADIENT_CRIMSON_TOP: 'gradient-crimson-top',
    GRADIENT_CRIMSON_LEFT: 'gradient-crimson-left',
    GRADIENT_ORANGE_TOP: 'gradient-orange-top',
    GRADIENT_ORANGE_LEFT: 'gradient-orange-left',
    GRADIENT_YELLOW_TOP: 'gradient-yellow-top',
    GRADIENT_YELLOW_LEFT: 'gradient-yellow-left',
    GRADIENT_LIGHTYELLOW_TOP: 'gradient-lightyellow-top',
    GRADIENT_LIGHTYELLOW_LEFT: 'gradient-lightyellow-left',
    GRADIENT_LIGHTGREEN_TOP: 'gradient-lightgreen-top',
    GRADIENT_LIGHTGREEN_LEFT: 'gradient-lightgreen-left',
    GRADIENT_LIME_TOP: 'gradient-lime-top',
    GRADIENT_LIME_LEFT: 'gradient-lime-left',
    GRADIENT_GREEN_TOP: 'gradient-green-top',
    GRADIENT_GREEN_LEFT: 'gradient-green-left',
    GRADIENT_TEAL_TOP: 'gradient-teal-top',
    GRADIENT_TEAL_LEFT: 'gradient-teal-left',
    GRADIENT_CYAN_TOP: 'gradient-cyan-top',
    GRADIENT_CYAN_LEFT: 'gradient-cyan-left',
    GRADIENT_LIGHTBLUE_TOP: 'gradient-lightblue-top',
    GRADIENT_LIGHTBLUE_LEFT: 'gradient-lightblue-left',
    GRADIENT_STEELBLUE_TOP: 'gradient-steelblue-top',
    GRADIENT_STEELBLUE_LEFT: 'gradient-steelblue-left',
};

export const THEMES = [
    AllColors.PRIMARY,
    AllColors.ADDITIONAL,
    AllColors.SUCCESS,
    AllColors.WARNING,
    AllColors.DANGER,
];

export const COLORS = [
    AllColors.TRANSPARENT,
    AllColors.CURRENT_COLOR,
    AllColors.WHITE,
    AllColors.GRAY_ULTRA_LIGHT,
    AllColors.GRAY_LIGHT,
    AllColors.GRAY,
    AllColors.GRAY_DEEP,
    AllColors.BLACK,
    AllColors.BLUE,
    AllColors.INDIGO,
    AllColors.PURPLE,
    AllColors.LIGHTPINK,
    AllColors.PINK,
    AllColors.DEEPPINK,
    AllColors.CRIMSON,
    AllColors.ORANGE,
    AllColors.YELLOW,
    AllColors.LIGHTYELLOW,
    AllColors.LIGHTGREEN,
    AllColors.LIME,
    AllColors.GREEN,
    AllColors.TEAL,
    AllColors.CYAN,
    AllColors.LIGHTBLUE,
    AllColors.STEELBLUE,
];

export const GRADIENTS = [
    AllColors.GRADIENT_GREEN,
    AllColors.GRADIENT_ORANGE,
    AllColors.GRADIENT_PURPLE,
    AllColors.GRADIENT_YELLOW,
    AllColors.GRADIENT_BLUE,
    AllColors.GRADIENT_PINK,
    AllColors.GRADIENT_PALE_GREEN,
    AllColors.GRADIENT_PALE_ORANGE,
    AllColors.GRADIENT_PALE_PURPLE,
    AllColors.GRADIENT_PALE_YELLOW,
    AllColors.GRADIENT_PALE_BLUE,
    AllColors.GRADIENT_PALE_PINK,

    AllColors.GRADIENT_PRIMARY_TOP,
    AllColors.GRADIENT_PRIMARY_LEFT,
    AllColors.GRADIENT_ADDITIONAL_TOP,
    AllColors.GRADIENT_ADDITIONAL_LEFT,
    AllColors.GRADIENT_SUCCESS_TOP,
    AllColors.GRADIENT_SUCCESS_LEFT,
    AllColors.GRADIENT_WARNING_TOP,
    AllColors.GRADIENT_WARNING_LEFT,
    AllColors.GRADIENT_DANGER_TOP,
    AllColors.GRADIENT_DANGER_LEFT,

    AllColors.GRADIENT_WHITE_TOP,
    AllColors.GRADIENT_WHITE_LEFT,
    AllColors.GRADIENT_GRAY_ULTRA_LIGHT_TOP,
    AllColors.GRADIENT_GRAY_ULTRA_LIGHT_LEFT,
    AllColors.GRADIENT_GRAY_LIGHT_TOP,
    AllColors.GRADIENT_GRAY_LIGHT_LEFT,
    AllColors.GRADIENT_GRAY_TOP,
    AllColors.GRADIENT_GRAY_LEFT,
    AllColors.GRADIENT_GRAY_DEEP_TOP,
    AllColors.GRADIENT_GRAY_DEEP_LEFT,
    AllColors.GRADIENT_BLACK_TOP,
    AllColors.GRADIENT_BLACK_LEFT,
    AllColors.GRADIENT_BLUE_TOP,
    AllColors.GRADIENT_BLUE_LEFT,
    AllColors.GRADIENT_INDIGO_TOP,
    AllColors.GRADIENT_INDIGO_LEFT,
    AllColors.GRADIENT_PURPLE_TOP,
    AllColors.GRADIENT_PURPLE_LEFT,
    AllColors.GRADIENT_LIGHTPINK_TOP,
    AllColors.GRADIENT_LIGHTPINK_LEFT,
    AllColors.GRADIENT_PINK_TOP,
    AllColors.GRADIENT_PINK_LEFT,
    AllColors.GRADIENT_DEEPPINK_TOP,
    AllColors.GRADIENT_DEEPPINK_LEFT,
    AllColors.GRADIENT_CRIMSON_TOP,
    AllColors.GRADIENT_CRIMSON_LEFT,
    AllColors.GRADIENT_ORANGE_TOP,
    AllColors.GRADIENT_ORANGE_LEFT,
    AllColors.GRADIENT_YELLOW_TOP,
    AllColors.GRADIENT_YELLOW_LEFT,
    AllColors.GRADIENT_LIGHTYELLOW_TOP,
    AllColors.GRADIENT_LIGHTYELLOW_LEFT,
    AllColors.GRADIENT_LIGHTGREEN_TOP,
    AllColors.GRADIENT_LIGHTGREEN_LEFT,
    AllColors.GRADIENT_LIME_TOP,
    AllColors.GRADIENT_LIME_LEFT,
    AllColors.GRADIENT_GREEN_TOP,
    AllColors.GRADIENT_GREEN_LEFT,
    AllColors.GRADIENT_TEAL_TOP,
    AllColors.GRADIENT_TEAL_LEFT,
    AllColors.GRADIENT_CYAN_TOP,
    AllColors.GRADIENT_CYAN_LEFT,
    AllColors.GRADIENT_LIGHTBLUE_TOP,
    AllColors.GRADIENT_LIGHTBLUE_LEFT,
    AllColors.GRADIENT_STEELBLUE_TOP,
    AllColors.GRADIENT_STEELBLUE_LEFT,
];

export const APP_COLORS = [
    ...THEMES,
    ...COLORS,
    ...GRADIENTS,
];
